import api from '@/api_alv'
import Vue from 'vue'
import { router } from '@/router.js'
import i18n from '@/assets/i18n/i18n'
import axios from 'axios'

const DIR = 'label/tracks'

// TODO
const DEFAULT_TRACK = {
    "id": 0,
    "alvId": "ALV000000000LT",
    "title": null,
    "trackName2": null,
    "trackName3": null,
    "trackName4": null,
    "trackName5": null,
    "artist": null,
    "isrc": null,
    "isrc2": null,
    "isrc3": null,
    "isrc4": null,
    "country": null,
    "year": null,
    "otherCode": null,
    "tags": null,
    "notes": null,
    "duration": null,
    "initialDate": null,
    "rightsOwnershipFrom": null,
    "copyright": null,
    "classicalWork": null,
    "language": null,
    "labelId": null,
    "explicit": 'no',
    "live": 'no',
    "instrumental": 'no',
    "work": null,
    "otherIds": []
}

const DEFAULT_ARTISTS = {
    "id"        : 0,
    "artist"    : null,
    "role"      : null,
    "primary"   : 'no'
}

const DEFAULT_GLOC = {
    "id"            : 0,
    "azObject"      : null,
    "glocSalesType"     : null,
    "split"         : null,
    "statementText" : null,
    "glocNotes"     : null
}

const DEFAULT_OTHER_IDS = {
    "id"            : 0,
    "sourceAlvId"   : null,
    "otherId"       : null
}

const state = {
// Tracks List Page    
    tracks: [],
    selectedTracks: [],
    isAllSelectedTracks: false,
    tracksSearch: '',
    tracksSideSortingOptions: {
        sortBy: ['isrc'],
        sortDesc: [true],
        mustSort: true
    },

// Filters & Actions & Buttons
    selectedTracksAction: [],
    selectedTracksLabelsFilter:[],
    selectedTracksQualityFilter:[],

    // Add Contracts
    contractsForTracksSearch: '',
    selectedContractsForTracks: [],
    // totalContractsForTracksListed: 0,
    // totalContractsForTracksRecords: 0,

    // Import (Mapping)
    tracksImportTags: "",
    tracksImportSelectedMapping: null,

// Details
    defaultNewTrack: DEFAULT_TRACK,
    trackUniqueId: '',
    expandedTracks: [],
    trackDetails: {},
    trackDetailsConnectedWork: null,
    trackDetailsConnectedArtist: null,
    releasesDropdown: [],
    labelsDropdown: [],
    // Connect Work with Track
    worksForTracksSearch: '',
    selectedWorksForTracks: [],
    // Connect Artist with Track
    artistForTracksSearch: '',
    totalListedConnectArtistToTrackDialog: 0,
    totalRecordsConnectArtistToTrackDialog: 0,
    selectedArtistForTracks: [],
    labelTracksDetailsSelectedAzTypeForArtist: null,

    // CONTRACTS Panel
    trackContracts: [],

    // ARTISTS Panel
    tracksArtists: [],
    tracksArtistsArtistOptions: [],
    showTracksArtistsEditingDialog: false,
    defaultTracksArtists: DEFAULT_ARTISTS,
    tracksArtistsEditingDialogDetails: DEFAULT_ARTISTS,
    selectedTracksArtists: [],

    // MEDIA Panel
    tracksMedia: [],
    tracksMediaCheckbox:[],

    // GLOC Panel
    tracksGloc: [],
    tracksGlocAzObjectOptions: [],
    showTracksGlocEditingDialog: false,
    defaultTracksGloc: DEFAULT_GLOC,
    tracksGlocEditingDialogDetails: DEFAULT_GLOC,
    selectedTracksGloc: [],

    // OTHER IDS Panel
    tracksOtherIds: [],
    tracksOtherIdsSearch: '',
    selectedTracksOtherIds: [],
    defaultTracksOtherIds: DEFAULT_OTHER_IDS,
    tracksOtherIdsEditingDialogDetails: DEFAULT_OTHER_IDS,
    showTracksOtherIdsEditingDialog: false,

    // Edit Form
    selectedReleaseId: null
}

const getters = {
// Tracks List Page
    getTracks                                               (state) { return state.tracks },
    getSelectedTracks                                       (state) { return state.selectedTracks },
    getIsAllSelectedTracks                                  (state) { return state.isAllSelectedTracks },
    getTracksSearch                                         (state) { return state.tracksSearch },
    getTracksServerSideSortingOptions                       (state) { return state.tracksSideSortingOptions },

// Filters & Actions & Buttons
    getSelectedTracksAction         (state) { return state.selectedTracksAction },
    getSelectedTracksLabelsFilter   (state) { return state.selectedTracksLabelsFilter },
    getSelectedTracksQualityFilter  (state) { return state.selectedTracksQualityFilter},

    // Add Contracts
    getContractsForTracksSearch     (state) { return state.contractsForTracksSearch },
    getSelectedContractsForTracks   (state) { return state.selectedContractsForTracks },

    // Import (Mapping)
    getTracksDetailsImportTags              (state) { return state.tracksImportTags },
    getTracksDetailsImportSelectedMapping   (state) { return state.tracksImportSelectedMapping },

    // Details  
    getDefaultNewTrack      (state) { return state.defaultNewTrack },
    getTracksUniqueId       (state) { return state.trackUniqueId },   
    getExpandedTracks       (state) { return state.expandedTracks },
    getTracksDetails        (state) { return state.trackDetails },
    getTrackDetailsAlvId    (state) { return state.trackDetails.alvId },
    getReleasesDropdown     (state) { return state.releasesDropdown },
    getLabelsDropdown       (state) { return state.labelsDropdown },
    // Connect Work with Track
    getWorksForTracksSearch(state) { return state.worksForTracksSearch },
    getSelectedWorksForTracks(state) { return state.selectedWorksForTracks },
    // Connect Artist with Track
    getArtistForTracksSearch(state) { return state.artistForTracksSearch },
    getSelectedArtistForTracks(state) { return state.selectedArtistForTracks },
    getLabelTracksDetailsSelectedAzTypeForArtist(state) { return state.labelTracksDetailsSelectedAzTypeForArtist },
    getTotalListedConnectArtistToTrackDialog(state) { return state.totalListedConnectArtistToTrackDialog },
    getTotalRecordsConnectArtistToTrackDialog(state) { return state.totalRecordsConnectArtistToTrackDialog },
    // TODO - add other fields, dropdowns, E, L, I & Format date
    getTrackDetailsTrackTitle(state) { return state.trackDetails.title },
    getTrackDetailsSelectedLanguageId(state) { return state.trackDetails.language },
    getTrackDetailsVersion(state) { return state.trackDetails.version },
    getTrackDetailsTrackName2(state) { return state.trackDetails.trackName2 },
    getTrackDetailsTrackName3(state) { return state.trackDetails.trackName3 },
    getTrackDetailsTrackName4(state) { return state.trackDetails.trackName4 },
    // getTrackDetailsTrackName5(state) { return state.trackDetails.trackName5 },
    getTrackDetailsArtist(state) { return state.trackDetails.artist },
    getTrackDetailsISRC(state) { return state.trackDetails.isrc },
    getTrackDetailsISRC2(state) { return state.trackDetails.isrc2 },
    getTrackDetailsISRC3(state) { return state.trackDetails.isrc3 },
    getTrackDetailsISRC4(state) { return state.trackDetails.isrc4 },
    getTrackDetailsCountry(state) { return state.trackDetails.country },
    getSelectedTrackYear(state) { return state.trackDetails.year },
    getTrackDetailsOtherCode(state) { return state.trackDetails.otherCode },     
    getTrackDetailsTags(state) { return state.trackDetails.tags },     
    getTrackDetailsNotes(state) { return state.trackDetails.notes }, 
    getTrackDetailsWork(state) { return state.trackDetails.work },
    getTrackDetailsDuration(state) { return state.trackDetails.duration },
    getTrackDetailsInitialDate(state) { return state.trackDetails.initialDate },
    getTrackDetailsRightsOwnershipFrom(state) {return state.trackDetails.rightsOwnershipFrom },
    getTrackDetailsCopyright(state) { return state.trackDetails.copyright },
    getTrackDetailsClassicalWork(state) { return state.trackDetails.classicalWork },
    getTrackDetailsReleases(state) { return state.trackDetails.releases },
    getTrackDetailsSelectedReleaseId(state) { return state.selectedReleaseId },
    getTrackDetailsSelectedLabelId(state) { return state.trackDetails.labelId },
    getTrackDetailsExplicit(state) { return state.trackDetails.explicit },
    getTrackDetailsLive(state) { return state.trackDetails.live },
    getTrackDetailsInstrumental(state) { return state.trackDetails.instrumental },
    getTrackDetailsConnectedWork(state) { return state.trackDetailsConnectedWork },
    getTrackDetailsConnectedArtist(state) { return state.trackDetailsConnectedArtist },

    // CONTRACTS Panel
    getTrackContracts(state) { return state.trackContracts },

    // ARTISTS Panel
    getTracksArtists(state) { return state.tracksArtists },
    getTracksArtistsArtistOptions(state) { return state.tracksArtistsArtistOptions },
    getShowTracksArtistsEditingDialog(state) { return state.showTracksArtistsEditingDialog },
    getDefaultTracksArtists(state) { return state.defaultTracksArtists },
    getTracksArtistsEditingDialogDetails(state) { return state.tracksArtistsEditingDialogDetails },
    getTracksArtistsDetailsArtist(state) { return state.tracksArtistsEditingDialogDetails.artist },
    getTracksArtistsDetailsRole(state) { return state.tracksArtistsEditingDialogDetails.role },
    getTracksArtistsDetailsPrimary(state) { return state.tracksArtistsEditingDialogDetails.primary },
    getSelectedTracksArtists(state) { return state.selectedTracksArtists },

    // MEDIA Panel
    getTracksMedia(state) { return state.tracksMedia },
    getTracksMediaCheckbox(state) { return state.tracksMediaCheckbox },

    // GLOC Panel
    getTracksGloc(state)                                    { return state.tracksGloc },
    getTracksGlocAzObjectOptions(state)                     { return state.tracksGlocAzObjectOptions },
    getShowTracksGlocEditingDialog(state)                   { return state.showTracksGlocEditingDialog },
    getDefaultTracksGloc(state)                             { return state.defaultTracksGloc },
    getTracksGlocEditingDialogDetails(state)                { return state.tracksGlocEditingDialogDetails },
    getTracksGlocDetailsAzObject(state)                     { return state.tracksGlocEditingDialogDetails.azObject },
    getTracksGlocDetailsSplit(state)                        { return state.tracksGlocEditingDialogDetails.split },
    getTracksGlocDetailsStatementText(state)                { return state.tracksGlocEditingDialogDetails.statementText },
    getTracksGlocDetailsGlocNotes(state)                    { return state.tracksGlocEditingDialogDetails.glocNotes },
    getTracksGlocDetailsGlocSalesType(state)                { return state.tracksGlocEditingDialogDetails.glocSalesType },
    getSelectedTracksGloc(state)                            { return state.selectedTracksGloc },

    // OTHER IDS Panel
    getTracksOtherIds(state)                                { return state.tracksOtherIds },
    getTracksOtherIdsSearch(state)                          { return state.tracksOtherIdsSearch },
    getSelectedTracksOtherIds(state)                        { return state.selectedTracksOtherIds },
    getDefaultTracksOtherIds(state)                         { return state.defaultTracksOtherIds },
    getShowTracksOtherIdsEditingDialog(state)               { return state.showTracksOtherIdsEditingDialog },
    getTracksOtherIdsEditingDialogDetails(state)            { return state.tracksOtherIdsEditingDialogDetails },
    getTracksOtherIdsDetailsSourceAlvId(state)              { return state.tracksOtherIdsEditingDialogDetails.sourceAlvId },
    getTracksOtherIdsDetailsOtherId(state)                  { return state.tracksOtherIdsEditingDialogDetails.otherId },

    }

const mutations = {
// Tracks List Page    
    setTracks:                                              (state, tracks) => { state.tracks = tracks },
    setSelectedTracks:                                      (state, selected) => { state.selectedTracks = selected },
    setIsAllSelectedTracks:                                 (state, isSelected) => { state.isAllSelectedTracks = isSelected },
    setTracksSearch:                                        (state, search) => { state.tracksSearch = search },
    setTracksServerSideSortingOptions:                      (state, value) => { state.tracksSideSortingOptions = value},   

// Filters & Actions & Buttons
    setSelectedTracksAction:        (state, action) => { state.selectedTracksAction = action },
    setSelectedTracksLabelsFilter:  (state, action) => { state.selectedTracksLabelsFilter = action },
    setSelectedTracksQualityFilter: (state, action) => { state.selectedTracksQualityFilter = action},

    // Add Contracts
    setContractsForTracksSearch:    (state, search) => { state.contractsForTracksSearch = search },
    setSelectedContractsForTracks:  (state, selected) => { state.selectedContractsForTracks = selected },

    // Import (Mapping)
    setTracksDetailsImportTags:             (state, value) => { state.tracksImportTags = value },
    setTracksDetailsImportSelectedMapping:  (state, value) => { state.tracksImportSelectedMapping = value }, 
    // Details  
    setDefaultNewTrack: (state) => { state.defaultNewTrack = DEFAULT_TRACK },
    setTracksUniqueId: (state, id) => { state.trackUniqueId = id },
    setExpandedTracks: (state, track) => { 
        if(Object.keys(track).length === 0) state.expandedTracks = []
        else state.expandedTracks.push(track) 
    },
    setTracksDetails: (state, details) => { state.trackDetails = details },
    setReleasesDropdown: (state, options) => { state.releasesDropdown = options },
    setLabelsDropdown: (state, options) => { state.labelsDropdown = options },
    // Connect Work with Track
    setWorksForTracksSearch: (state, search) => { state.worksForTracksSearch = search },
    setSelectedWorksForTracks: (state, selected) => { state.selectedWorksForTracks = selected },
    // Connect Artist with Track
    setArtistForTracksSearch: (state, search) => { state.artistForTracksSearch = search },
    setSelectedArtistForTracks: (state, selected) => { state.selectedArtistForTracks = selected },
    setLabelTracksDetailsSelectedAzTypeForArtist: (state, type) => { state.labelTracksDetailsSelectedAzTypeForArtist = type },
    setTotalListedConnectArtistToTrackDialog: (state, value) => { state.totalListedConnectArtistToTrackDialog = value },
    setTotalRecordsConnectArtistToTrackDialog: (state, value) => { state.totalRecordsConnectArtistToTrackDialog = value },

    setTrackDetailsAlvId: (state, alvId) => { state.trackDetails.alvId = alvId },
    setTrackDetailsTrackTitle: (state, title) => { state.trackDetails.title = title },
    setTrackDetailsSelectedLanguageId: (state, selectedLanguageId) => { state.trackDetails.language = selectedLanguageId },
    setTrackDetailsVersion: (state, version) => { state.trackDetails.version = version },
    setTrackDetailsTrackName2: (state, trackName2) => { state.trackDetails.trackName2 = trackName2 },
    setTrackDetailsTrackName3: (state, trackName3) => { state.trackDetails.trackName3 = trackName3 },
    setTrackDetailsTrackName4: (state, trackName4) => { state.trackDetails.trackName4 = trackName4 },
    // setTrackDetailsTrackName5: (state, trackName5) => { state.trackDetails.trackName5 = trackName5 },
    setTrackDetailsArtist:                  (state, artist) => { state.trackDetails.artist = artist },
    setTrackDetailsISRC:                    (state, value) => { state.trackDetails.isrc = (value == null ? value : value.trim()) },
    setTrackDetailsISRC2:                   (state, value) => { state.trackDetails.isrc2 = (value == null ? value : value.trim()) },
    setTrackDetailsISRC3:                   (state, value) => { state.trackDetails.isrc3 = (value == null ? value : value.trim()) },
    setTrackDetailsISRC4:                   (state, value) => { state.trackDetails.isrc4 = value },
    setSelectedTrackYear:                   (state, value) => { state.trackDetails.year = value },
    setTrackDetailsCountry:                   (state, value) => { state.trackDetails.country = (value || null) },
    setTrackDetailsOtherCode:               (state, otherCode) => { state.trackDetails.otherCode = otherCode },
    setTrackDetailsTags: (state, tags) => { state.trackDetails.tags = tags },
    setTrackDetailsNotes: (state, notes) => { state.trackDetails.notes = notes },
    setTrackDetailsWork: (state, work) => { state.trackDetails.work = work },
    setTrackDetailsDuration: (state, duration) => { state.trackDetails.duration = duration },
    setTrackDetailsInitialDate: (state, initialDate) => { state.trackDetails.initialDate = initialDate },
    setTrackDetailsRightsOwnershipFrom: (state, value) => { state.trackDetails.rightsOwnershipFrom = value },
    setTrackDetailsCopyright: (state, copyright) => { state.trackDetails.copyright = copyright },
    setTrackDetailsClassicalWork: (state, classicalWork) => { state.trackDetails.classicalWork = classicalWork },
    setTrackDetailsReleases: (state, releases) => { state.trackDetails.releases = releases },
    setTrackDetailsSelectedReleaseId: (state, selectedReleaseId) => { state.selectedReleaseId = selectedReleaseId },
    setTrackDetailsSelectedLabelId: (state, labelId) => { state.trackDetails.labelId = labelId },
    setTrackDetailsExplicit: (state, explicit) => { state.trackDetails.explicit = explicit },
    setTrackDetailsLive: (state, live) => { state.trackDetails.live = live },
    setTrackDetailsInstrumental: (state, instrumental) => { state.trackDetails.instrumental = instrumental },
    setTrackDetailsSelectedLabelId: (state, id) => { state.trackDetails.labelId = id },
    setTrackDetailsConnectedWork: (state, work) => { state.trackDetailsConnectedWork = work },
    setTrackDetailsConnectedArtist: (state, artist) => { state.trackDetailsConnectedArtist = artist },

    // CONTRACTS Panel
    setTrackContracts: (state, contracts) => { state.trackContracts = contracts },

    // ARTISTS Panel
    setTracksArtists: (state, artists) => { state.tracksArtists = artists },
    setTracksArtistsArtistOptions: (state, options) => { state.tracksArtistsArtistOptions = options },
    setShowTracksArtistsEditingDialog: (state, show) => { state.showTracksArtistsEditingDialog = show },
    setDefaultTracksArtists: (state) => { state.defaultTracksArtists = DEFAULT_ARTISTS },
    setTracksArtistsEditingDialogDetails: (state, details) => { state.tracksArtistsEditingDialogDetails = details },
    setTracksArtistsDetailsArtist: (state, artist) => { state.tracksArtistsEditingDialogDetails.artist = artist },
    setTracksArtistsDetailsRole: (state, role) => { state.tracksArtistsEditingDialogDetails.role = role },
    setTracksArtistsDetailsPrimary: (state, primary) => { state.tracksArtistsEditingDialogDetails.primary = primary },
    setSelectedTracksArtists: (state, selected) => { state.selectedTracksArtists = selected },

     // MEDIA Panel
    setTracksMedia: (state, artists) => { state.tracksMedia = artists },
    setTracksMediaCheckbox: (state, value) => { state.tracksMediaCheckbox = value },

    // GLOC Panel
    setDefaultTracksGloc:                                   (state) => { state.defaultTracksGloc = DEFAULT_GLOC },
    setTracksGloc:                                          (state, value) => { state.tracksGloc = value },
    setTracksGlocAzObjectOptions:                           (state, value) => { state.tracksGlocAzObjectOptions = value },
    setShowTracksGlocEditingDialog:                         (state, value) => { state.showTracksGlocEditingDialog = value },
    setTracksGlocEditingDialogDetails:                      (state, value) => { state.tracksGlocEditingDialogDetails = value },
    setTracksGlocDetailsAzObject:                           (state, value) => { state.tracksGlocEditingDialogDetails.azObject = value },
    setTracksGlocDetailsSplit:                              (state, value) => { state.tracksGlocEditingDialogDetails.split = value },
    setTracksGlocDetailsStatementText:                      (state, value) => { state.tracksGlocEditingDialogDetails.statementText = value },
    setTracksGlocDetailsGlocNotes:                          (state, value) => { state.tracksGlocEditingDialogDetails.glocNotes = value },
    setTracksGlocDetailsGlocSalesType:                      (state, value) => { state.tracksGlocEditingDialogDetails.glocSalesType = value },
    setSelectedTracksGloc:                                  (state, value) => { state.selectedTracksGloc = value },

    // OTHER IDS Panel
    setTracksOtherIds:                                      (state, value) => { state.tracksOtherIds = value },
    setTracksOtherIdsSearch:                                (state, value) => { state.tracksOtherIdsSearch = value },
    setSelectedTracksOtherIds:                              (state, value) => { state.selectedTracksOtherIds = value },
    setDefaultTracksOtherIds:                               (state) => { state.defaultTracksOtherIds = DEFAULT_OTHER_IDS },
    setShowTracksOtherIdsEditingDialog:                     (state, value) => { state.showTracksOtherIdsEditingDialog = value },
    setTracksOtherIdsEditingDialogDetails:                  (state, value) => { state.tracksOtherIdsEditingDialogDetails = value },
    setTracksOtherIdsDetailsSourceAlvId:                    (state, value) => { state.tracksOtherIdsEditingDialogDetails.sourceAlvId = value },
    setTracksOtherIdsDetailsOtherId:                        (state, value) => { state.tracksOtherIdsEditingDialogDetails.otherId = value },

}

const actions = {
// Tracks List       
    async fetchTracks({ commit, getters }) {
        commit('setIsLoading', true)

        // check for set filters
        let filterObj = {
            'search' : getters.getTracksSearch,
            'labelId': getters.getSelectedTracksLabelsFilter,
            'quality': getters.getSelectedTracksQualityFilter
        }

        // create string of filter params for api call
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)

        // sorting options
        let options = getters.getTracksServerSideSortingOptions  

        // Get list items from db    
        let response = await api.getListData2(DIR, getters.getCurrentPage, options.sortBy, options.sortDesc, paramsString)      

        if(response === undefined || response.list.length === 0 || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setTracks', [])
        } else {
            response.list.forEach((element) => {
                element['isPlaying'] = false
            }); 

            commit('setTracks', response.list)
        }

        this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords)
        commit('setIsLoading', false)
    },

    // Fetch Details for a specific track     
    async fetchTracksDetails({ commit, getters, dispatch }, alvId) {

        let values

        if(alvId === 'new') {
            values = JSON.parse(JSON.stringify(getters.getDefaultNewTrack))
            commit('setDefaultTracksArtists')
            commit('setTracksMedia',[])
            commit('setDefaultTracksGloc')
            commit('setTracksGloc', []) 
        }
        else {
            let response = await api.getDetailsById(DIR, alvId) 

            if(response === undefined || response.length === 0 || response.error === 1) values = {}
            else {
                values = response
                values['duration'] = this._vm.$alvPlugin.transformSecondsToDuration(values['duration'])
            }
        }
        
        commit('setTracksDetails', values)
        commit('setTracksGloc', values.gloc || [])

        dispatch('fetchTrackLabels')
        dispatch('fetchTracksReleases')
        dispatch('fetchTracksArtists')
        dispatch('fetchTracksOtherIds')
        commit('setTrackDetailsConnectedWork', null)
        commit('setTrackDetailsConnectedArtist', null)
        if(alvId !== 'new') {
            if(values.language !== null) values.language = values.language.toLowerCase()
            if(values.work !== null) commit('setTrackDetailsConnectedWork', values.work.title)

            // Set the readonly field for artist.
            // because of legacy data we need to consider, that the artist can be a simple string as well,
            // because it was not always an autocomplete (az person/group) field.
            let artistName = null
            if (values.artist !== null && values.artist !== undefined) {
                if (typeof values.artist === 'object' && !Array.isArray(values.artist)) {
                    artistName = this._vm.$alvPlugin.showNameOfAzEntry(values.artist, true)
                } else {
                    artistName = values.artist
                }
            }
            commit('setTrackDetailsConnectedArtist', artistName)
            
            // if(values.artist !== null) 
            dispatch('fetchTracksMedia')
        }
        commit('setIsLoading', false)
    },
    /*
        Function will generate array for Label > Tracks > Edit Form > Label of Track Dropdown.
        Data will be used from store property 'labelCompanies' which is filled at first call after login.
        Will be called when edit form is opened, for editing existing or entering new track.
        In both cases dropdown needs to be filled.
        TODO FOR LATER: to be called when Label > Companies is updated.
    */
    fetchTrackLabels({getters, commit}) {           
        commit('setLabelCompanies')
        let labels = []
        let labelsDropdown = []
        getters.getLabelCompanies.forEach((labelCompany) => {
            if(labelCompany.labels != null) {
                labels = labels.concat(labelCompany.labels)
            }
        })

        labels.forEach((label) => {
            labelsDropdown.push({
                "value": parseInt(label.id),
                "text": label.name_alv,
                "alvId":label.alvId
            })
        })
        if(labelsDropdown === undefined || labelsDropdown.length === 0 || labelsDropdown.error === 1) labelsDropdown = []

        commit('setLabelsDropdown', labelsDropdown)
    },
    async fetchTracksReleases({ commit, getters }) {
        let alvId = getters.getTrackDetailsAlvId
        let releasesDropdown

        if(alvId === 'ALV000000000LT')  releasesDropdown = []
        else {
            releasesDropdown = await api.getSpecificDropdownValues(DIR, alvId, 'releases')

            if(releasesDropdown === undefined || releasesDropdown.length === 0 || releasesDropdown.error === 1) {
                releasesDropdown = []
            } else {
                commit('setTrackDetailsSelectedReleaseId', releasesDropdown[0]['value'])
            }            
        }
        
        commit('setReleasesDropdown', releasesDropdown)
    },

// Fetch Details for Contract Panel in Track Edit Form
    async fetchTrackContracts({ commit, getters}) {
        let contractsFromDB = getters.getTracksDetails.contracts
        commit('setIsLoading', false)

        if(contractsFromDB.length === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')

        commit('setTrackContracts', contractsFromDB)
    },

    // ARTISTS Panel
    async fetchTracksArtists({ commit, getters }) {
        let artistsFromDb = getters.getTracksDetails.artists

        if(artistsFromDb === undefined || artistsFromDb === null) artistsFromDb = []
        else if(artistsFromDb.length === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND') 

        commit('setTracksArtists', artistsFromDb)
    },
    // OTHER IDS Panel
    async fetchTracksOtherIds({ commit, getters }) {
        let idsFromDb = getters.getTracksDetails.otherIds

        if(idsFromDb === undefined || idsFromDb === null) commit('setTracksOtherIds', [])
        else {
            if(idsFromDb.length === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setTracksOtherIds', idsFromDb)
        }
    },

    // AUTOCOMPLETE: Artist
    async fetchAutocompleteTracksArtistsArtist({ commit }, input) {
        let response = await api.getAutocompleteSearch('az/persons', input)
        commit('setTracksArtistsArtistOptions', response.list)
    },

    // AUTOCOMPLETE: GLOC name
    async fetchAutocompleteTracksGlocAzObject({ commit }, input) {
        let response = await api.getAutocompleteSearch('az/persons', input)
        commit('setTracksGlocAzObjectOptions', response.list)
    },

    // DELETE Artist
    async deleteSelectedTracksArtists({ getters, commit }) {
        let selectedArtist = getters.getSelectedTracksArtists 
        let index = getters.getTracksArtists.findIndex(artist => artist.id === selectedArtist.id)

        let startAmount = getters.getTracksArtists.length
        Vue.delete(getters.getTracksArtists, index)
        let newAmount = getters.getTracksArtists.length

        if(startAmount > newAmount) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_LABEL_RELEASES_SNACKBAR_DELETE_ARTIST_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
                timeout: -1
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_LABEL_RELEASES_SNACKBAR_DELETE_ARTIST_NOT_SUCCESSFUL'), 
            })
        }

        commit('setSelectedTracksArtists', [])
        if(newAmount === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
    },

    // DELETE GLOC
    async deleteSelectedTracksGloc({ getters, commit }) {
        let selectedGloc = getters.getSelectedTracksGloc 
        let index = getters.getTracksGloc.findIndex(gloc => gloc.id === selectedGloc.id)

        let startAmount = getters.getTracksGloc.length
        Vue.delete(getters.getTracksGloc, index)
        let newAmount = getters.getTracksGloc.length

        if(startAmount > newAmount) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
                timeout: -1
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL'), 
            })
        }

        commit('setSelectedTracksGloc', [])
        if(newAmount === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
    },

    // DELETE Other ID
    async deleteSelectedTracksOtherIds({ getters, commit }) {
        let selectedId = getters.getSelectedTracksOtherIds // only one id is passed
        let index = getters.getTracksOtherIds.findIndex(id => {
            return JSON.stringify(id) === JSON.stringify(selectedId)
        })

        let startAmount = getters.getTracksOtherIds.length
        if(index !== -1) Vue.delete(getters.getTracksOtherIds, index)
        let newAmount = getters.getTracksOtherIds.length

        if(startAmount > newAmount) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
                timeout: -1
            })
        } else {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL'),
            })
        }

        commit('setSelectedTracksOtherIds', [])
        if(newAmount === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
    },

    //MEDIA Panel
    async fetchTracksMedia({ commit, getters }) {

        commit('setIsLoading', true)
        let alvId = getters.getTrackDetailsAlvId
        let mediaFromDB = await api.getListData(DIR + '/' + alvId + '/media')
        
        // if(mediaFromDB === undefined || mediaFromDB === null) mediaFromDB = []
        // else if(mediaFromDB.length === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND') 

        if(mediaFromDB === undefined || mediaFromDB === null){
            mediaFromDB = []
        } else if(mediaFromDB.length === 0){
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND') 
        }else{
            mediaFromDB.forEach((element) => {
                element['isPlaying'] = false
            });
        }

        commit('setTracksMedia', mediaFromDB)

        commit('setIsLoading', false)
    },

    // Work connection
    // DELETE
    async deleteWorkTrackConnection({ commit }) {
        commit('setTrackDetailsConnectedWork', null)
        commit('setTrackDetailsWork', null)
    },
    // SEARCH
    async searchWorksForTracks({ getters }) {
        let params = 'search=' + getters.getWorksForTracksSearch
        let response = await api.getListData("publishing/works", "1", params)
        return response.list
    },
    // ADD
    async addWorksToTracks({ getters, commit }) {
        let selectedWork = getters.getSelectedWorksForTracks
        delete selectedWork[0]['rowId']
        let trackDetails = getters.getTracksDetails
        trackDetails.work = selectedWork[0]
        commit('setTrackDetailsConnectedWork', trackDetails.work.title)
    },
    // AZ Person/Group = Artist connection
    // DELETE
    async deleteArtistTrackConnection({ commit }) {
        commit('setTrackDetailsConnectedArtist', null)
        commit('setTrackDetailsArtist', null)
    },
    // SEARCH
    async searchArtistForTracks({ getters, commit }) {
        let params = 'search=' + getters.getArtistForTracksSearch + '&type=artist&azType=persons,groups'
        // let response = await api.getListData("az/persons", "1", params)
        let response = await api.getListData("az", "1", params)

        commit('setTotalListedConnectArtistToTrackDialog', response.filteredRecords)
        commit('setTotalRecordsConnectArtistToTrackDialog', response.totalRecords)

        return response.list
    },
    // ADD
    async addArtistToTracks({ getters, commit }) {
        let selectedArtist = getters.getSelectedArtistForTracks[0] // always only 1 artist selected
        let trackDetails = getters.getTracksDetails
        trackDetails.artist = selectedArtist
        let azEntityName = this._vm.$alvPlugin.showNameOfAzEntry(trackDetails.artist, true)
        commit('setTrackDetailsConnectedArtist', azEntityName)
        commit('setTrackDetailsArtist', trackDetails.artist)
    },

// SAVE EDIT FORM
    async saveTracksForm({ commit, getters, dispatch }) {
        let alvId = getters.getTrackDetailsAlvId
        let metaData = getters.getTracksDetails
        metaData['artists'] = getters.getTracksArtists
        metaData['media'] = getters.getTracksMedia
        metaData['gloc'] = getters.getTracksGloc
        // new rows get a temporary negative id from the editing dialog; backend generates the real id
        metaData['otherIds'] = (getters.getTracksOtherIds || []).map(otherId => ({
            ...otherId,
            id: otherId.id > 0 ? otherId.id : null
        }))
        let isNew = router.currentRoute.params.alvId == "new"
        let response = await api.saveEditForm(DIR, alvId, metaData, isNew)

        // TODO send split % as float !!!!

        if(response === undefined || response.length === 0 || response.error === 1) { 
            response = []
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERAL_CAPTION_ERROR'), // TODO: better message for user
            })
        } else {            
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_SAVING_SUCCESSFUL')
            })
            // redirect if new, to set new ALV ID in edit form and URL
            if(isNew) {
                router.push( { name: 'TracksEdit', params: { alvId:  response.response.alvId } })
            }
            await dispatch('fetchTracksDetails',  response.response.alvId)
        }
    },

// ACTIONS Switch
    async doTracksAction({ commit, dispatch }) {
        switch(state.selectedTracksAction) {
            case 'delete':
                if(state.selectedTracks.length > 0) {
                    commit('setShowDeletionDialog', true)
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                    commit('setShowSelectionRequiredDialog', true)
                }                    
                break
            case 'labelcopy':
                if(state.selectedTracks.length > 0) {
                    dispatch('trackLabelCopy')
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                    commit('setShowSelectionRequiredDialog', true)
                }                    
                break
            case 'replaceTags':
                if(state.selectedTracks.length > 0) {
                    commit('setExpandedTracks', [])
                    commit('setShowManageTagsDialog', true)
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                    commit('setShowSelectionRequiredDialog', true)
                }
                break
            case 'addContract':
                if(state.selectedTracks.length > 0) {
                    commit('setSelectedTracksAction', []) 
                    commit('setExpandedTracks', [])
                    commit('setShowSearchDialog', true)
                } else {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
                    commit('setShowSelectionRequiredDialog', true)
                }
                break
            case 'copy':
                if(state.selectedTracks.length > 1 || state.selectedTracks.length === 0) {
                    commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE') 
                    commit('setShowSelectionRequiredDialog', true)
                }
                if(state.selectedTracks.length === 1) dispatch('copyTrack')
                break
        }
    },

    // Action: DELETE
    async deleteSelectedLabelTracks({ commit, getters, dispatch }) {
        const response = await api.deleteEntries(DIR, getters.getSelectedTracks)
        if(response.error === -1) {        
            for(let i = 0; i < getters.getSelectedTracks.length; i++) {
                let index = getters.getTracks.findIndex(release => release.alvId == getters.getSelectedTracks[i])
                Vue.delete(getters.getTracks, index)
            }

            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_ENTRY_DELETED')
            })
            
            commit('setSelectedTracks', [])
            commit('setIsAllSelectedTracks', false)
            commit('setSelectedTracksAction', [])
            dispatch('fetchTracks')
        }
    },

    // Action: LABELCOPY
    async trackLabelCopy({ commit, getters }) {
        let queryParams = { "action": "trackLabelCopy"}
        let metaData = { "trackIds" : getters.getSelectedTracks }

        let response = await api.triggerAction(DIR, metaData, queryParams)

        if(response.error === -1) {
            if(response.response.path !== null) {
                api.getFileFromALV(response.response.path)
                commit('setSnackbar', {
                    type: 'success',
                    msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
                })
            }
        } else {
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            }
        }
    },

    // Action: ADD CONTRACTS to tracks
    // Add
    async addContractsToTracks({ getters, commit }) {
        let metaData = {
            "trackIds" : getters.getSelectedTracks,
            "contractIds": getters.getSelectedContractsForTracks
        }

        let response = await api.addContracts(DIR, metaData)
        
        if(response.error === -1) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERAL_SNACKBAR_ADDED_SUCCESSFULLY')
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_ADDING_WAS_NOT_SUCCESSFUL'),
            })
        }
    },
    // Search
    async searchContractsForTracks({ getters }) {
        let params = 'search=' + getters.getContractsForTracksSearch + '&trackIds=' + getters.getSelectedTracks.join(',')
        let response = await api.getListData("contracts/label", "1", params)
        return response
    },
    
    // Action: COPY track
    async copyTrack({ getters, commit, dispatch}) {
        let queryParams = { "action": "copy" }
        let metaData = { "alvIds": getters.getSelectedTracks }

        let response = await api.triggerAction(DIR, metaData, queryParams)
        
        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERAL_SNACKBAR_COPY_SUCCESSFULL')
            })
            dispatch('fetchTracks')
        } else {
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            }
        }
    },
    //DELETE MEDIA FILE 

    async deleteLabelTracksMediaFile({getters,commit,dispatch},clickedMediaType){
        let alvId = getters.getTrackDetailsAlvId
        let response = await api.deleteFile(DIR + "/" + alvId,"?deleteMedia",{"media" : clickedMediaType })
        if(response.error === -1) {
            dispatch("fetchTracksMedia")
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL')
            })
        } else {
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            }
        }

    }
}

export default {
    state, getters, actions, mutations
}